import {
  Row,
  Modal,
  Button,
  Col,
  Form
} from 'react-bootstrap';

import styles from './Erp.module.css';
import cipaUnidades from '../../helpers/cipaUnidades';

const radios = [
  { id: '0', nome: 'Sem acesso' },
  { id: '1', nome: 'Consulta' },
  { id: '2', nome: 'Gravação' },
  { id: '3', nome: 'Exclusão' },
];

const Erp = props => {
  return (
    <>
      <Row className={styles.title}>ERP - (MXM)</Row>

      <Row>
        <Col sm={12}>
          <Form.Group controlId="erpNome" className="mt-4">
            <Form.Label>*Nome completo:</Form.Label>
            <Form.Control
              type="text"
              required
              name="erpNome"
              onChange={props.handleErpNome}
              value={props.erpNome}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <Form.Group controlId="erpEmail" className="mt-4">
            <Form.Label>*e-mail:</Form.Label>
            <Form.Control
              type="text"
              required
              name="erpEmail"
              onChange={props.handleErpEmail}
              value={props.erpEmail}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <Form.Group controlId="erpMatricula" className="mt-4">
            <Form.Label>*Matrícula:</Form.Label>
            <Form.Control
              type="text"
              required
              name="erpMatricula"
              onChange={props.handleErpMatricula}
              value={props.erpMatricula}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <Form.Group controlId="erpUnidade" className="mt-4 mb-4 pb-4">
            <Form.Label>*Lotação:</Form.Label>
            <Form.Select
              className="border border-secondary"
              name="erpUnidade"
              onChange={props.handleErpUnidade}
              value={props.erpUnidade}
            >
              <option value="">Selecione a lotação</option>
              {cipaUnidades.map(item => (
                <option key={item} value={item}>{item}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpAdministrador' className="mt-2">
            <Form.Label className={styles.confirm}>Administrador:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpAdministrador === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpAdministrador'
                  type="radio"
                  id={`erpAdministrador-${item.id}`}
                  onChange={props.handleErpAdministrador}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpCadastrosComuns' className="mt-1">
            <Form.Label className={styles.confirm}>Cadastros Comuns:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpCadastrosComuns === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpCadastrosComuns'
                  type="radio"
                  id={`erpCadastrosComuns-${item.id}`}
                  onChange={props.handleErpCadastrosComuns}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpCadastrosComumFinanceiro' className="mt-1">
            <Form.Label className={styles.confirm}>Cadastros Comum Financeiro:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpCadastrosComumFinanceiro === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpCadastrosComumFinanceiro'
                  type="radio"
                  id={`erpCadastrosComumFinanceiro-${item.id}`}
                  onChange={props.handleErpCadastrosComumFinanceiro}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpGestaoDeProcessos' className="mt-1">
            <Form.Label className={styles.confirm}>Gestão de Processos:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpGestaoDeProcessos === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpGestaoDeProcessos'
                  type="radio"
                  id={`erpGestaoDeProcessos-${item.id}`}
                  onChange={props.handleErpGestaoDeProcessos}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpCompras' className="mt-1">
            <Form.Label className={styles.confirm}>Compras:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpCompras === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpCompras'
                  type="radio"
                  id={`erpCompras-${item.id}`}
                  onChange={props.handleErpCompras}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpContratoCompras' className="mt-1">
            <Form.Label className={styles.confirm}>Contrato Compras:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpContratoCompras === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpContratoCompras'
                  type="radio"
                  id={`erpContratoCompras-${item.id}`}
                  onChange={props.handleErpContratoCompras}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpContasPagar' className="mt-1">
            <Form.Label className={styles.confirm}>Contas Pagar:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpContasPagar === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpContasPagar'
                  type="radio"
                  id={`erpContasPagar-${item.id}`}
                  onChange={props.handleErpContasPagar}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpPagamentoEscritural' className="mt-1">
            <Form.Label className={styles.confirm}>Pagamento Escritural:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpPagamentoEscritural === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpPagamentoEscritural'
                  type="radio"
                  id={`erpPagamentoEscritural-${item.id}`}
                  onChange={props.handleErpPagamentoEscritural}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpContasReceber' className="mt-1">
            <Form.Label className={styles.confirm}>Contas Receber:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpContasReceber === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpContasReceber'
                  type="radio"
                  id={`erpContasReceber-${item.id}`}
                  onChange={props.handleErpContasReceber}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>
      
      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpTesouraria' className="mt-1">
            <Form.Label className={styles.confirm}>Tesouraria:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpTesouraria === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpTesouraria'
                  type="radio"
                  id={`erpTesouraria-${item.id}`}
                  onChange={props.handleErpTesouraria}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpIntegracaoPadrao' className="mt-1">
            <Form.Label className={styles.confirm}>Integração Padrão:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpIntegracaoPadrao === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpIntegracaoPadrao'
                  type="radio"
                  id={`erpIntegracaoPadrao-${item.id}`}
                  onChange={props.handleErpIntegracaoPadrao}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpContabil' className="mt-1">
            <Form.Label className={styles.confirm}>Contábil:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpContabil === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpContabil'
                  type="radio"
                  id={`erpContabil-${item.id}`}
                  onChange={props.handleErpContabil}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpEstoque' className="mt-1">
            <Form.Label className={styles.confirm}>Estoque:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpEstoque === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpEstoque'
                  type="radio"
                  id={`erpEstoque-${item.id}`}
                  onChange={props.handleErpEstoque}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpPatrimonio' className="mt-1">
            <Form.Label className={styles.confirm}>Patrimônio:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpPatrimonio === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpPatrimonio'
                  type="radio"
                  id={`erpPatrimonio-${item.id}`}
                  onChange={props.handleErpPatrimonio}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpOrcamento' className="mt-1">
            <Form.Label className={styles.confirm}>Orçamento:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpOrcamento === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpOrcamento'
                  type="radio"
                  id={`erpOrcamento-${item.id}`}
                  onChange={props.handleErpOrcamento}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpReinf' className="mt-1">
            <Form.Label className={styles.confirm}>REINF:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpReinf === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpReinf'
                  type="radio"
                  id={`erpReinf-${item.id}`}
                  onChange={props.handleErpReinf}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpEfd' className="mt-1">
            <Form.Label className={styles.confirm}>EFD:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpEfd === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpEfd'
                  type="radio"
                  id={`erpEfd-${item.id}`}
                  onChange={props.handleErpEfd}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpEcd' className="mt-1">
            <Form.Label className={styles.confirm}>ECD:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpEcd === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpEcd'
                  type="radio"
                  id={`erpEcd-${item.id}`}
                  onChange={props.handleErpEcd}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Row className={styles.bg_color}>
        <Col sm={12}>
          <Form.Group controlId='erpEcf' className="mt-1">
            <Form.Label className={styles.confirm}>ECF:</Form.Label>
            {radios.map(item => {
              return (
                <Form.Check
                  key={item.id}
                  value={`${item.id} - ${item.nome}`}
                  checked={props.erpEcf === `${item.id} - ${item.nome}`}
                  className={styles.radio}
                  inline
                  label={`${item.id} - ${item.nome}`}
                  name='erpEcf'
                  type="radio"
                  id={`erpEcf-${item.id}`}
                  onChange={props.handleErpEcf}
                />
              );
            })}
          </Form.Group>
        </Col>
      </Row>

      <Modal show={props.showErpModal} onHide={props.handleErpModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.erpError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleErpModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Erp;
// TODO erp